import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationUser, AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { UsersService } from 'src/app/Services/users.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ArtistsService } from 'src/app/Services/artists.service';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-onboarding-artist-resume',
    templateUrl: './onboarding-artist-resume.component.html',
    styleUrls: ['./onboarding-artist-resume.component.css'],
    standalone: false
})
export class OnboardingArtistResumeComponent implements OnInit {
    @Output() onSave = new EventEmitter<ApplicationUser>();
    public formData!: ApplicationUser;
    public userId!: string;
    public selectedArtTypes: string[] = [];
    public authConfig: AuthConfig = {};
    public isArtist: boolean | undefined = false;
    public editorConfig: AngularEditorConfig = {
        outline: true,
        rawPaste: true,
        editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '200px',
        toolbarHiddenButtons: [
            ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
            ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
        ],
    }
    public resumeEditorConfig: AngularEditorConfig = {
        outline: true,
        rawPaste: true,
        editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '200px',
        toolbarHiddenButtons: [
            ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
            ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
        ],
    }
    constructor(
        private authService: AuthService,
        private usersService: UsersService,
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private transloco: TranslocoService,
    )  {
        this.formData = new ApplicationUser();
      }

    ngOnInit() {
        this.userId = this.authService.getUserId();
        this.authConfig = this.authService.getAuthConfig();
        this.isArtist = this.authConfig.IsArtist;
        this.getUserById();
    }

    private getUserById() {
        this.ngxSpinnerService.show();
        this.usersService.getUserDetails().subscribe(
            (res) => {
                this.formData = res;
                console.log(this.formData);
                this.ngxSpinnerService.hide();
            },
            (error) => {
                console.error('Error fetching the logged-in user: ', error);
                this.ngxSpinnerService.hide();
            }
        );
    }

    public updateProfile() {
        this.ngxSpinnerService.show();
        this.usersService.updateUser(this.formData.Id, this.formData).subscribe(
            (response: ResponseObject) => {
                this.ngxSpinnerService.hide();
                if (response.Success) {
                    this.onSave.emit(this.formData); // Emit the updated user data
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistResume.successTitle'), this.transloco.translate('onboardingArtistResume.changesSavedSuccessfully'), NotificationTypes.Success);
                } else {
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistResume.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
                }
            },
            (error) => {
                console.error(error);
                this.ngxSpinnerService.hide();
            }
        );
    }
}
